import { detailRowToCrumb, labelLastCrumb, listSectionToCrumb } from 'components/breadcrumbs/utils/breadcrumb'
import { createDetailCrumbKey, createDetailUrl, getCurrentDetailCrumbs } from 'components/view/utils/view'
import Settings from 'helpers/settings'
import { goToUrl } from 'hooks/process'

export const toListRow = ({translator, notifier, row, detail, section, currentDetail, navigate}) => {
  const cells   = section.fields.reduce((obj, field, index) => ({...obj, [field.key]: row[index + 1]}), {})
  const id      = row[0] 
  const onClick = detail && (e => { 
    const detailUrl     = createDetailUrl(detail, id)
    const variable      = createDetailCrumbKey(detail, id)
    const currentCrumbs = getCurrentDetailCrumbs(currentDetail?.detail, currentDetail?.id)
    labelLastCrumb(currentCrumbs, currentDetail?.label)
    const newCrumbs     = !currentDetail
      ? [listSectionToCrumb(translator, notifier, section), detailRowToCrumb(cells, detail, id)]
      : [detailRowToCrumb(cells, detail, id)]

    Settings.session.write(variable, [...currentCrumbs, ...newCrumbs])

    goToUrl(navigate, detailUrl, e.ctrlKey) 
  })

  return { cells, id, onClick, rowProps: {color: '#172b4d', fontSize: '12px'} }
}
